/* RESPONSIBLE TEAM: team-standalone */

import type { ConversationExcerptData } from '../definitions';
import type FreshdeskPlatform from '../../freshdesk';

export default class FreshdeskConversationExcerpt implements ConversationExcerptData {
  private platform: FreshdeskPlatform;

  constructor(platform: FreshdeskPlatform) {
    this.platform = platform;
  }

  title = (excerptsEnabled: boolean) => {
    let defaultPrefix = 'fin-ai-agent.knowledge.content-sources.conversation-excerpts';
    let prefix = excerptsEnabled ? `${defaultPrefix}.enabled` : defaultPrefix;
    return this.platform.intl.t(`${prefix}.default`);
  };

  get link() {
    return undefined;
  }
}
